export const CampData = [
    {
        Campaign_ID : "XASDADSA56",
        Headed_By: "Donald Trump" ,
        Department_name: "Development",
        Budget : 1200,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 120000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 12000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 12000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 12000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 12000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 12000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 12000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 12000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 12000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 12000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 12000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 12000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 12000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 12000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 12000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 12000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 12000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 12000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },{
        Campaign_ID : "XASDADSA98",
        Headed_By: "Joe Dee" ,
        Department_name: "Development",
        Budget : 12000,
        Started_on : "28/06/2022",
        Goals : "Shoes",
        Duration :"18 months"
    },
]